


































































































import { Component, Vue, Watch } from "vue-property-decorator";
import DadosBasicos from "./DadosBasicos.vue";
import Especialidades from "./Especialidades.vue";
import Profissionais from "./Profissionais.vue";
import GsModalDialog from "@/components/modal/GsModalDialog.vue";
import { CadastroPrestadorModel } from "@/models/cadastros/saude/CadastroPrestadorModel";
import { prestadorSaudeStore } from "@/store/cadastros/saude/PrestadorSaudeStore";
import { cadastroPrestadorService } from "@/service/cadastro/saude/CadastroPrestadorService";
import { TipoPessoa } from "@/models/cadastros/saude/DadosBasicosPrestadorModel";

@Component({
  components: {
    DadosBasicos,
    Especialidades,
    Profissionais,
    GsModalDialog,
  },
})
export default class CadastroPrestador extends Vue {
  $refs!: {
    dadosBasicos: InstanceType<typeof DadosBasicos>;
    especialidadesRef: InstanceType<typeof Especialidades>;
    profissionais: InstanceType<typeof Profissionais>;
  };

  dialogType = "";
  showDialog = false;
  dialogTitle = "";
  dialogMessage = "";

  // modalMensagemSalvar = false;
  // textoMensagemSalvar = "";
  // mensagemErro = false;

  tab = "dados-basicos";

  cadastroPrestador = {
    dadosBasicosPrestador: {
      cpfCnpj: "",
      tipoPessoa: TipoPessoa.FISICA,
      nome: "",
      email: "",
      flagCadastroCPOM: false,
      telefones: [],
      endereco: {},
      contaBancaria: {
        contaPrincipal: true,
      },
      ativo: true
    },
    especialidadesPrestador: [],
    profissionaisPrestador: [],
  } as CadastroPrestadorModel;

  mounted() {
    if (this.$route.params.idPrestador) {
      cadastroPrestadorService
        .obterPrestador(Number(this.$route.params.idPrestador))
        .then((cadastroPrestador) => {
          this.cadastroPrestador = cadastroPrestador;
          this.cadastroPrestador.id = Number(this.$route.params.idPrestador);
        })
        .catch((err) => {
          console.error(err.message);
          this.$router.back();
        });
    }
  }

  @Watch("tab")
  tabChange(value: string, oldValue: string) {
    switch (oldValue) {
      case "dados-basicos":
        prestadorSaudeStore.SET_DADOS_BASICOS(
          this.cadastroPrestador.dadosBasicosPrestador
        );
        break;
      case "especialidades":
        break;
      case "profissionais":
        break;
    }
  }

  get especialidadesPrestador() {
    return (
      this.cadastroPrestador.especialidadesPrestador.map(
        (ep) => ep.especialidade
      ) || []
    );
  }

  salvar() {
    this.$refs.dadosBasicos.validar().then((valid) => {
      if (valid) {
        this.$refs.especialidadesRef.validar(valid).then((validado) => {
          if (validado) {
            cadastroPrestadorService
              .salvarPrestador(this.cadastroPrestador)
              .then(() => {
                this.openDialog('success', 'Sucesso', 'Prestador cadastrado com sucesso.');
              })
              .catch((err) => {
                this.openDialog('error', 'Erro', err.message);
              })
              .finally(() => {});
          } else {
            this.tab = "especialidades";
            setTimeout(this.$refs.especialidadesRef.scrollToError, 300);
          }
        });
      } else {
        this.tab = "dados-basicos";
        setTimeout(this.$refs.dadosBasicos.scrollToError, 300);
      }
    });
  }
  
  cancelar() {
    this.$router.push({ name: "ListagemPrestadores" });
  }

  private openDialog(dialogType: string, title: string, message: string) {
    this.dialogType = dialogType;
    this.dialogTitle = title;
    this.dialogMessage = message;
    this.showDialog = true;
  }

  public closeDialog(): void {
    if (this.dialogType == 'success') {
      this.$router.replace({ name: "ListagemPrestadores" });
    }
    this.showDialog = false;
  }

  get btnColor() {
    let color: string;
    switch (this.dialogType) {
      case "success":
        color = "#00CD96";
        break;
      case "error":
        color = "error";
        break;
      case "confirm":
        color = "error";
        break;
      default:
        color = "primary";
        break;
    }
    return color;
  }

  get btnText() {
    let text: string;
    switch (this.dialogType) {
      case "success":
        text = "Ok, entendi";
        break;
      case "error":
        text = "Fechar";
        break;
      case "confirm":
        text = "Cancelar";
        break;
      default:
        text = "Ok, entendi";
        break;
    }
    return text;
  }

  get dialogImg() {
    return `${this.dialogType}.png`;
  }
}
